import { gql } from '@apollo/client';
import TableSettingsFragment from '../../fragments/TableSettings/TableSettings';

const UPDATE_INCOMING_ORDERS_TABLE_SETTINGS = gql`mutation updateTableSettings($fields: [CompanyTableSettingInput!]) {
	incomingOrders {
		updateTableSetting(fields: $fields) {
			culture
			fields
			{
				field
				label
				settings
			}
		}
	}	
}`;
export default UPDATE_INCOMING_ORDERS_TABLE_SETTINGS;